<mat-card>
  <div class="row">
    <div class="col-md-10">
<h2>ORDERS LIST</h2></div>
<div class="col-md-2">
</div></div>
<div class="row">
 
<div class="col-md-8">

  <mat-form-field class="search">
    <mat-label>Search</mat-label>
    <input (keyup)="applyFilter($event.target.value)" matInput placeholder="Search"   >
    </mat-form-field>
</div>
<div class="col-md-4 text-center"></div>
</div>
<table mat-table [dataSource]="memberss" matSort>
    <!-- <ng-container matColumnDef="image">
<th mat-header-cell *matHeaderCellDef mat-sort-header>Image </th>
<td mat-cell *matCellDef="let member"> </td>
</ng-container> -->
  <ng-container matColumnDef="OrderID" >
<th mat-header-cell *matHeaderCellDef mat-sort-header>ORDER_ID</th>
<td mat-cell *matCellDef="let member"   style="color: black;" (click) = "take(member.id)">  {{member.id}} </td>
</ng-container>
  <ng-container matColumnDef="customer_mobile">
<th mat-header-cell *matHeaderCellDef mat-sort-header>CUSTOMER MOBILE NO</th>
<td mat-cell *matCellDef="let member" (click) = "take(member.id)" role="gridcell"> {{member.customers.phone}} </td>
</ng-container>
  <ng-container matColumnDef="order_date"><!--HH:mm:ss-->
<th mat-header-cell *matHeaderCellDef mat-sort-header>ORDER DATE</th>
<td mat-cell *matCellDef="let member" (click) = "take(member.id)" role="gridcell"> {{member.createdAt | date:'medium'}} </td>
</ng-container>

  <ng-container matColumnDef="Customer_Name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>CUSTOMER NAME</th>
    <td mat-cell *matCellDef="let member" (click) = "take(member.id)" role="gridcell"> {{member.customers.fullname}}<br>{{member.customers.email}} </td>
    </ng-container>

<ng-container matColumnDef="dishesNo" >
    <th mat-header-cell *matHeaderCellDef mat-sort-header >NO OF DISHES</th>
    <td mat-cell *matCellDef="let member" (click) = "take(member.id)" role="gridcell"> {{member.dishes.length}} </td>
    </ng-container>
    <ng-container matColumnDef="address" >
        <th mat-header-cell *matHeaderCellDef mat-sort-header >ADDRESS</th>
        <td mat-cell *matCellDef="let member" (click) = "take(member.id)" role="gridcell"> {{member.address}} </td>
        </ng-container>
            <ng-container matColumnDef="ORDER_STATUS" >
              <th mat-header-cell *matHeaderCellDef mat-sort-header >ORDER STATUS</th>
              <td mat-cell *matCellDef="let member"role="gridcell" >
                <mat-form-field>
                  <mat-select [(ngModel)]="member.orderStatus" (selectionChange)="changeOrderStatus(member.id,member)">
                    <mat-option value="Pending">Pending</mat-option>
                    <mat-option value="In_Kitchen">In Kitchen</mat-option>
                    <mat-option value="Ready">Ready</mat-option>
                    <mat-option value="Cancelled">Cancelled</mat-option>
                    <mat-option value="Delivered">Delivered</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              </ng-container>
<ng-container matColumnDef="TotalPrice"  >
<th mat-header-cell *matHeaderCellDef>TOTAL PRICE</th>
<td mat-cell *matCellDef="let member" role="gridcell">{{member.totalPrice}}</td>
</ng-container>

<!--in row which column will display is assigned in displayedColumns-->
<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row  (click)="logData(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
  
			 </table>
<mat-paginator [length]="15" [pageSize]="5" [pageSizeOptions]="[5,10,15]" showFirstLastButtons></mat-paginator>
</mat-card>
